import { useState } from 'react'
import { ClubInfo, FixtureRow } from '../store/club'
import { apiSeasonEnd } from '../server/ServiceCall'
import { AuthState } from '../store/auth'


interface Props {
  auth:         AuthState
  club:         ClubInfo
  nextMatch:    FixtureRow | null
  recent:       FixtureRow[]
  onGoSquad:    () => void
  onGoFixtures: () => void
  onSeasonEnded: () => void
}

function formatDate(dt: string): string {
  return (dt || '').slice(0, 10)
}

export default function Dashboard({ auth, club, nextMatch, recent, onGoSquad, onGoFixtures, onSeasonEnded }: Props) {
  const seasonReady = club.CURRENT_ROUND >= (club.ROUND_TOTAL || 46)
  const [busy, setBusy] = useState(false)
  const [msg,  setMsg]  = useState('')

  async function handleSeasonEnd() {
    if (!window.confirm(`시즌 ${club.SEASON_NO} 을(를) 종료합니다.\n— 모든 클럽 통계 0 리셋\n— NPC 선수단 전면 재생성\n— 시즌 ${club.SEASON_NO + 1} 시작 + 새 일정 생성\n— 사용자 구단 전술은 IS_VALID=0 (재확정 권장)\n\n진행할까요?`)) return
    setBusy(true); setMsg('시즌 종료 처리 중…')
    const r = await apiSeasonEnd(auth.token, club.LEAGUE_CODE)
    setBusy(false)
    setMsg(`${r.resultCode === '00' ? '✅' : '⚠️'} ${r.resultMessage}`)
    if (r.resultCode === '00') onSeasonEnded()
  }

  return (
    <div className="page-pad dashboard">
      {seasonReady && (
        <section className="card season-end-banner">
          <h3>🏆 시즌 {club.SEASON_NO} 종료 가능</h3>
          <p>모든 라운드가 진행되었습니다. 시즌을 종료하면 NPC 풀이 새로 생성되고 시즌 {club.SEASON_NO + 1}이 시작됩니다.</p>
          <button className="btn-season-end" onClick={handleSeasonEnd} disabled={busy}>
            {busy ? '처리 중…' : '시즌 종료 + 새 시즌 시작'}
          </button>
          {msg && <span className="season-msg">{msg}</span>}
        </section>
      )}

      <section className="card club-card">
        <h2>{club.CLUB_NAME}</h2>
        <p className="sub">{club.HOME_STADIUM} · 수용 {club.STADIUM_CAPACITY.toLocaleString()}명</p>
        <div className="grid-2">
          <div><label>현금</label><strong>₩ {club.CASH.toLocaleString()}</strong></div>
          <div><label>신용등급</label><strong>{club.CREDIT_GRADE}</strong></div>
          <div><label>평판</label><strong>{club.REPUTATION}</strong></div>
          <div><label>리그</label><strong>{club.LEAGUE_NAME} · 시즌 {club.SEASON_NO}</strong></div>
          <div><label>현재 라운드</label><strong>R{club.CURRENT_ROUND} / {club.ROUND_TOTAL || 46}</strong></div>
          <div><label>등급</label><strong>{club.TIER || '-'}부</strong></div>
          <div><label>순위</label><strong>{club.LEAGUE_RANK > 0 ? club.LEAGUE_RANK + '위' : '미정'}</strong></div>
        </div>
        <div className="record">
          {club.WIN_CNT}승 {club.DRAW_CNT}무 {club.LOSE_CNT}패 · 득{club.GOAL_FOR} 실{club.GOAL_AGAINST} · 승점 {club.POINTS}
        </div>
      </section>

      <section className="card">
        <h3>다음 경기</h3>
        {nextMatch ? (
          <div className="next-match">
            <span className="date">{formatDate(nextMatch.MATCH_DATE)} · R{nextMatch.ROUND_NO}</span>
            <span className="home">{nextMatch.HOME_NAME}</span>
            <span className="vs">vs</span>
            <span className="away">{nextMatch.AWAY_NAME}</span>
          </div>
        ) : <p className="muted">예정된 경기 없음</p>}
      </section>

      <section className="card">
        <h3>최근 결과</h3>
        {recent.length === 0 ? <p className="muted">아직 종료된 경기가 없습니다.</p> : (
          <ul className="fixture-list">
            {recent.map(f => (
              <li key={f.FIXTURE_CODE} className="fixture-row">
                <span className="date">{formatDate(f.MATCH_DATE)} · R{f.ROUND_NO}</span>
                <span className="home">{f.HOME_NAME}</span>
                <span className="score">{f.HOME_GOAL} : {f.AWAY_GOAL}</span>
                <span className="away">{f.AWAY_NAME}</span>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className="quick-links">
        <button onClick={onGoSquad}>선수단 보기</button>
        <button onClick={onGoFixtures}>일정·순위 보기</button>
      </section>
    </div>
  )
}
